<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Stock de un producto
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Reportes y Consultas</span>
      <span> /</span>
      <span class="grey-text">Inventario</span>
      <span> /</span>
      <span>Stock de un producto</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body align-items-center">
        <div class="col" style="max-width: 250px;">
          <div class="md-form">
            <mdb-date-picker [inline]="true" name="fecha_movimiento" [placeholder]="'Fecha'"
              formControlName="fecha_movimiento">
            </mdb-date-picker>
          </div>
        </div>
        <div class="col" style="max-width: 150px;">
          <div class="md-form">
            <input value="" type="text" id="codProduct" class="form-control" placeholder="000" #codProduct
              formControlName="sku" />
            <label for="codProduct">Código de producto</label>
            <div *ngIf="formHeader.get('sku').invalid && (formHeader.get('sku').dirty || formHeader.get('sku').touched)">
              <mdb-error *ngIf="formHeader.get('sku').hasError('required')">Ingrese SKU Producto </mdb-error>
            </div>
          </div>
        </div>
        <div class="col d-flex" style="max-width: 300px;">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="openModalSeleccionarProducto()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;" *ngIf="productoSeleccionado">
            {{ productoSeleccionado.descripcion}}
          </h6>
        </div>
        <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsBodega" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Bodega" formControlName="bodega"></mdb-select>
            <label>Bodega</label>
          </div>
        </div>
        <!-- <div class="col" style="max-width: 300px;">
          <div class="md-form">
            <mdb-select [options]="optionsFormato" [multiple]="true" [filterEnabled]="true" [highlightFirst]="false"
              placeholder="Seleccionar Formato" formControlName="formato"></mdb-select>
            <label>Formato</label>
          </div>
        </div> -->
      </div>

    </div>
    <!-- FOOTER -->
    <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
      <div></div>
      <button mdbBtn type="button" color="secondary" size="sm" mdbWavesEffect (click)="buscar(1)">
        <mdb-icon fas icon="search"></mdb-icon>
        Buscar
      </button>
    </div>
  </div>
</form>

<div class="card mb-2 wow detalle-cliente">
  <div class="card-body justify-content-between">
    <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>
    <div class="table-responsive" *ngIf="listaMovimientos">
      <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
      </app-no-data-alert>
      <table class="table table-striped table-hover table-sm align-middle" *ngIf="listaMovimientos?.length > 0">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">SKU</th>
            <th scope="col">Producto</th>
            <th scope="col">Bodega</th>
            <th scope="col" style="text-align: right;">Caja</th>
            <th scope="col" style="text-align: right;">Fraccion</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let mov of listaMovimientos">
            <td>{{mov.sku}}</td>
            <td>{{mov.producto_descripcion}}</td>
            <td>{{mov.bodega_nombre}}</td>
            <td align="right">{{calcularStockFormatoPrincipal(mov.listaStockxUnidades) | numerico}}</td>
            <td align="right">{{calcularStockFormatoSecundario(mov.listaStockxUnidades) | numerico}}</td>
          </tr>
        </tbody>
        <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
          *ngIf="listaMovimientos?.length > 0"></app-pagination>
      </table>
    </div>
  </div>
</div>

<div class="card mb-2 wow" *ngIf="listaMovimientos?.length > 0">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect class="btn" (click)="exportarExcel()">
      Excel
    </button>
  </div>
</div>

<!-- MODAL seleccionarProducto -->
<app-modal-seleccionar-producto [showFiltroActivoInactivo]="false" (onSelect)="onProductoSeleccionado($event)"
  (onNotFound)="onProductoNoEncontrado()">
</app-modal-seleccionar-producto>